/* eslint-disable import/no-extraneous-dependencies */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import matchAll from "string.prototype.matchall";
import allSettled from "promise.allsettled";

import ReactDOM from "react-dom";

import "@grapecity/wijmo.styles/wijmo.css";
import * as wjcCore from "@grapecity/wijmo";

import App from "common/app/app.component";
import "./index.css";
import AppProviders from "common/context/app-providers";

wjcCore.setLicenseKey(
  "flexi,715154219476768#B0M6ZRrI4Yn94aWB7VK5GNnJEeB5mUtJXZvw6KCxEcmNmbuVjMslld8YkSLdjajxWQSRUSzR4Y5F5czNWRypldnJEaoBnQEJVaGFDelZTYmZnN4xESnhGe9Q4Zz3mSyhzL93UNZdlavh7QJNVUrl7cItCd42kTMxUO9k5QnRFakNTUwdXS8YGM6EXcvYlc52WayNkZ7RDcjZDZWtWRvUzTLhUY6NmWCdEOwYXeOJXOaR4dGFWS6U6UhtEZqFnY8NnUBlUV4k7Nx8WaxMTQKRWRzdmQntkTsxmUz4mRVJHesVzZ8oGVFh7Vwd7c8RUUadXNOpUazVmZ5plc7tWVUBFUyljVvNkI0IyUiwiIGZkQ4AzM5IiOigkIsgDO8UDN5IDO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyebpjIkJHUiwiIxATOwUDMgcDMwEDMyAjMiojI4J7QiwiIlJXY7RnZvNFIsFmbvlGdh9mclRnbJlGelxmRiojIh94QiwiI8YzN6cDN9EjM4UTM5EzNiojIklkIs4nIzYHMyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TUkpmRoFTU7olSM36ZzUDUCV7cydDV584Qat4QStkMvMnbwIzRLlmYzpndLpkbzIkWvU6LM5UW6oUTvR4ZM3mSBJTMzsmYEZnaVJlbUFlTNFkM",
);

matchAll.shim();
allSettled.shim();

if (process.env.NODE_ENV === "development") {
  import("common/mocks/browser").then(({ worker }) => {
    (async () => {
      // see https://mswjs.io/docs/getting-started/integrate/browser#using-homepage-property-in-packagejson
      if (!window.location.pathname.endsWith("/")) {
        window.location.pathname = `${window.location.pathname}/`;
        return;
      }

      await worker.start({
        serviceWorker: {
          url: `${window.location.pathname}mockServiceWorker.js`,
        },
        onUnhandledRequest: "bypass",
      });
    })();
  });
}

ReactDOM.render(
  <AppProviders>
    <App />
  </AppProviders>,
  document.getElementById("root"),
);
